<template>
  <div class="LKPublicationsDataCollectionLeft__col--left">
    <div class="LKPublicationsDataCollectionLeft__name">
      Контекстные данные
    </div>
    <div class="LKPublicationsDataCollectionLeft__bottom">
      <div
        :class="statusStyle"
        class="LKPublicationsDataCollectionLeft__status"
        v-text="statusText"
      />
    </div>
  </div>
</template>


<script>
import LKPublicationsDataCollectionLeft
  from '@/views/LKPublications/components/LKPublicationsDataCollection/LKPublicationsDataCollectionLeft.vue'
import { LkPassportStatus } from '@/typings/api/Passport'

export default {
  name: 'LKPassportContextualDataLeft',
  extends: LKPublicationsDataCollectionLeft,
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusStyle() {
      return {
        'is-opened': this.data.status === 'IN_PROGRESS' || 'NOT_STARTED',
        'is-done': this.data.status === 'submited',
      }
    },
    statusText() {
      switch (this.data.status) {
        case LkPassportStatus.IN_PROGRESS:
          return 'В работе'
        case LkPassportStatus.SUBMITTED:
          return 'Сдано'
        case LkPassportStatus.NOT_STARTED:
          return 'Не приступал'
        default:
          return 'Открыт'
      }
    },
  },
}
</script>

<style lang="scss">
.LKMunMehCardFormLeft {
  &__bottom-text {
    margin-top: 8px;
    font-size: 12px;
    color: $webflow-color-blue-dark-2;
  }
}
</style>
